import { render, staticRenderFns } from "./userInfo.vue?vue&type=template&id=160e5512&scoped=true"
import script from "./userInfo.vue?vue&type=script&lang=js"
export * from "./userInfo.vue?vue&type=script&lang=js"
import style0 from "./userInfo.vue?vue&type=style&index=0&id=160e5512&prod&lang=less&scoped=true"
import style1 from "./userInfo.vue?vue&type=style&index=1&id=160e5512&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160e5512",
  null
  
)

export default component.exports